import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { TablerIconsModule } from 'angular-tabler-icons';
import { LocalizationPipe } from '../../../../pipe/localization-pipe';

export interface QaSimpleModalData {
  question: string;
  answer: string;
  tags?: string[];
  fileName: string;
}

@Component({
  selector: 'app-qa-simple-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatChipsModule,
    MatDividerModule,
    TablerIconsModule,
    LocalizationPipe
  ],
  template: `
    <div class="qa-modal-container">
      <div class="qa-modal-header">
        <h2 mat-dialog-title>
          <i-tabler name="help-circle" class="me-2"></i-tabler>
          {{ 'QASimpleModalTitle' | localize }}
        </h2>
        <p class="file-subtitle">{{ data.fileName }}</p>
      </div>

      <mat-dialog-content class="qa-modal-content">
        <div class="qa-section">
          <h6 class="section-title">
            <i-tabler name="message-question" class="me-2"></i-tabler>
            {{ 'QASimpleModalQuestion' | localize }}
          </h6>
          <div class="question-content">
            {{ data.question }}
          </div>
        </div>

        <mat-divider class="my-3"></mat-divider>

        <div class="qa-section">
          <h6 class="section-title">
            <i-tabler name="message-2" class="me-2"></i-tabler>
            {{ 'QASimpleModalAnswer' | localize }}
          </h6>
          <div class="answer-content">
            {{ data.answer }}
          </div>
        </div>

        <div *ngIf="data.tags && data.tags.length > 0" class="tags-section">
          <mat-divider class="my-3"></mat-divider>
          <h6 class="section-title">
            <i-tabler name="tag" class="me-2"></i-tabler>
            {{ 'QASimpleModalTags' | localize }}
          </h6>
          <mat-chip-set>
            <mat-chip *ngFor="let tag of data.tags" class="tag-chip">
              {{ tag }}
            </mat-chip>
          </mat-chip-set>
        </div>
      </mat-dialog-content>

      <mat-dialog-actions align="end" class="qa-modal-actions">
        <button mat-button mat-dialog-close>
          {{ 'QASimpleModalClose' | localize }}
        </button>
      </mat-dialog-actions>
    </div>
  `,
  styles: [`
    .qa-modal-container {
      width: 100%;
      max-width: 600px;
    }

    .qa-modal-header {
      padding: 20px 24px 0;
    }

    .qa-modal-header h2 {
      margin: 0;
      font-size: 20px;
      font-weight: 600;
      color: #333;
      display: flex;
      align-items: center;
    }

    .file-subtitle {
      margin: 8px 0 0 0;
      font-size: 14px;
      color: #666;
    }

    .qa-modal-content {
      padding: 20px 24px;
      min-height: 200px;
    }

    .qa-section {
      margin-bottom: 20px;
    }

    .section-title {
      margin: 0 0 12px 0;
      font-size: 14px;
      font-weight: 600;
      color: #555;
      display: flex;
      align-items: center;
    }

    .question-content,
    .answer-content {
      background: #f8f9fa;
      padding: 16px;
      border-radius: 8px;
      border-left: 4px solid #1976d2;
      line-height: 1.6;
      color: #333;
      word-wrap: break-word;
    }

    .answer-content {
      border-left-color: #4caf50;
    }

    .tags-section {
      margin-top: 20px;
    }

    .tag-chip {
      background: #e3f2fd;
      color: #1976d2;
      font-size: 12px;
      margin: 0 4px 4px 0;
    }

    .qa-modal-actions {
      padding: 16px 24px 20px;
    }

    /* Responsive */
    @media (max-width: 480px) {
      .qa-modal-container {
        max-width: 95vw;
      }

      .qa-modal-header,
      .qa-modal-content,
      .qa-modal-actions {
        padding-left: 16px;
        padding-right: 16px;
      }
    }
  `]
})
export class QaSimpleModalComponent {
  constructor(
    public dialogRef: MatDialogRef<QaSimpleModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: QaSimpleModalData
  ) {}
}
